import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

type ResourceItem = {
  id: string
  displayName: string
}

type Props = {
  label: string
  items: ResourceItem[]
  mode: 'all' | 'specific'
  selectedIds: string[]
  onModeChange: (mode: 'all' | 'specific') => void
  onSelectedIdsChange: (ids: string[]) => void
  idPrefix?: string
}

export const ResourceScopeSelector = ({
  label,
  items,
  mode,
  selectedIds,
  onModeChange,
  onSelectedIdsChange,
  idPrefix = '',
}: Props) => {
  return (
    <div className="rounded-lg border overflow-hidden">
      <div className="flex items-center px-4 py-2.5 bg-muted/50">
        <Label className="text-xs font-medium text-muted-foreground">
          {label}
        </Label>
      </div>
      <RadioGroup
        value={mode}
        onValueChange={(value) => onModeChange(value as 'all' | 'specific')}
        className="divide-y"
      >
        <Label className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-muted/30">
          <RadioGroupItem
            value="all"
            id={`${idPrefix}scope-all`}
            className="shrink-0 data-[state=checked]:border-primary"
          />
          <span className="text-sm">All {label.toLowerCase()}</span>
        </Label>
        <div>
          <Label className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-muted/30">
            <RadioGroupItem
              value="specific"
              id={`${idPrefix}scope-specific`}
              className="shrink-0 data-[state=checked]:border-primary"
            />
            <span className="text-sm">Specific {label.toLowerCase()}</span>
          </Label>
          {mode === 'specific' ? (
            <div className="border-t divide-y bg-muted/10">
              {items.length > 0 ? (
                items.map((item) => {
                  const isChecked = selectedIds.includes(item.id)
                  return (
                    <Label
                      key={item.id}
                      className="flex items-center gap-3 pl-10 pr-4 py-2.5 cursor-pointer hover:bg-muted/50"
                    >
                      <Checkbox
                        id={`${idPrefix}resource-${item.id}`}
                        checked={isChecked}
                        onCheckedChange={(checked) => {
                          if (checked) {
                            onSelectedIdsChange([...selectedIds, item.id])
                          } else {
                            onSelectedIdsChange(
                              selectedIds.filter((id) => id !== item.id)
                            )
                          }
                        }}
                      />
                      <span className="text-sm">{item.displayName}</span>
                    </Label>
                  )
                })
              ) : (
                <div className="pl-10 pr-4 py-3 text-sm text-muted-foreground">
                  No resources available
                </div>
              )}
            </div>
          ) : null}
        </div>
      </RadioGroup>
    </div>
  )
}
